export default {
  portfolioSection: {
    authorImage: require('@/assets/img/author.jpg'),
    authorNameChinese: '曹 瑜璇',
    authorNameEnglish: 'Cao Yuxuan',
    quote: "Every journey begins in silence — but ends in self-transcendence.",
    brand: {
      acronym: "O.Y.I.M.",
      description: "Open Your Inner Mind (Unleash Your Creative Potential)"
    }
  },
  webDesign: {
    title: "Web Design",
    subtitle: "Designing impactful and user-friendly websites",
    projects: [
      {
        id: 1,
        image: require('@/assets/img/web/dress_menu.png'),
        alt: "Wedding Hill Tokyo Bay Makuhari Dress Catalog",
        title: "Dress Catalog",
        description: "A responsive dress catalog developed for Wedding Hill Tokyo Bay Makuhari. This Single Page Application features an elegant UI optimized for both desktop and mobile devices, allowing couples to browse an extensive collection of wedding dresses with a smooth, interactive experience.",
        techStack: ["React", "HTML5", "CSS3", "typeScript"],
        link: "https://www.weddinghill.jp/weddinghill_menu",
        category: "Business Venue Website",
        year: "2025"
      },
      {
        id: 2,
        image: require('@/assets/img/web/cirq.png'),
        alt: "CIRQ Website",
        title: "CIRQ Website",
        description: "An elegant and luxurious business venue website offering wedding halls and event spaces for conferences, parties, and business gatherings across Japan. Features a premium design that showcases 62 facilities nationwide with comprehensive venue information and booking services.",
        techStack: ["WordPress", "HTML5", "CSS3", "JavaScript"],
        link: "https://www.cirq-hall.jp/",
        category: "Business Venue Website",
        year: "2025"
      },
      {
        id: 3,
        image: require('@/assets/img/web/20th.png'),
        alt: "20th Website",
        title: "20th Website",
        description: "A 20th anniversary website that presents the company’s achievements in a clear and engaging way, using numbers to help customers understand its journey and success.",
        techStack: ["HTML", "CSS3", "JavaScript"],
        link: "https://www.tkp.jp/20th/",
        category: "Anniversary Website",
        year: "2025"
      },
      {
        id: 4,
        image: require('@/assets/img/web/onuma.png'),
        alt: "Onuma’s Personal Website",
        title: "Onuma’s Personal Website",
        description: "Designed and developed a portfolio website for Tokyo artist Onuma Kumiko, showcasing her skull-themed acrylic paintings and artistic journey. The site uses a clean, gallery-focused layout and expressive typography to reflect her vibrant pop-art style.",
        techStack: ["WordPress", "HTML", "CSS3", "JavaScript"],
        link: "https://onuma-kumiko.net/",
        category: "Personal Website",
        year: "2023"
      },
      {
        id: 5,
        image: require('@/assets/img/web/jongno.jpg'),
        alt: "Jongno Website",
        title: "Jongno Website",
        description: "An official website that highlights Jongno’s key products and achievements with a clean and concise layout.",
        techStack: ["WordPress", "HTML5", "CSS3", "JavaScript"],
        link: "https://korea-town.jp/",
        category: "Official Website",
        year: "2022"
      },
      {
        id: 6,
        image: require('@/assets/img/web/rakuten.png'),
        alt: "Jongno Rakuten Website",
        title: "Jongno Rakuten Website",
        description: "A visually engaging e-commerce site on Rakuten, designed to showcase Jongno’s featured products and strong brand identity.",
        techStack: ["HTML5", "CSS3", "JavaScript"],
        link: "https://www.rakuten.ne.jp/gold/jongno-cheesehatogu/",
        category: "E-commerce",
        year: "2023"
      },
      {
        id: 7,
        image: require('@/assets/img/web/com.png'),
        alt: "Tkp communications Website",
        title: "Tkp communications Website",
        description: "A modern corporate site for TKP Communications, featuring a responsive layout and user-centered content structure.",
        techStack: ["HTML5", "CSS3", "JavaScript"],
        link: "https://tkpcom.jp/",
        category: "Official Website",
        year: "2024"
      },
      {
        id: 8,
        image: require('@/assets/img/web/translation.png'),
        alt: "Translation Service Website",
        title: "Translation Service Website",
        description: "A focused landing page introducing the company’s professional translation services with a clean, minimal design.",
        techStack: ["HTML5", "CSS3"],
        link: "https://journal-digitallife.com/translation/",
        category: "Information",
        year: "2022"
      },
      {
        id: 9,
        image: require('@/assets/img/web/abroad.png'),
        alt: "Abroad Service Website",
        title: "Abroad Service Website",
        description: "A streamlined landing page introducing the company's study abroad and international support services.",
        techStack: ["HTML5", "CSS3"],
        link: "https://journal-digitallife.com/study-abroad/",
        category: "Information",
        year: "2022"
      }
    ]
  },
  graphicDesign: {
    title: "Graphic Design",
    subtitle: "Visual Communication & Brand Identity",
    projects: [
      {
        id: 1,
        image: require('@/assets/img/graphic/Cosmetics/01.jpg'),
        alt: "Cosmetics banner 1",
        title: "Cosmetics banner 1",
        description: "An animated banner that effectively showcases the hair growth brush’s features through dynamic and eye-catching motion graphics.",
        techStack: ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe Illustrator"],
        client: "Cosmetics Brand",
        category: "Banner",
        year: "2022"
      },
      {
        id: 2,
        image: require('@/assets/img/graphic/Cosmetics/02.gif'),
        alt: "Cosmetics banner 2",
        title: "Cosmetics banner 2",
        description: "An animated banner that effectively showcases the hair growth brush’s features through dynamic and eye-catching motion graphics.",
        techStack: ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe Illustrator"],
        client: "Cosmetics Brand",
        category: "Banner",
        year: "2022"
      },
      {
        id: 3,
        image: require('@/assets/img/graphic/Cosmetics/03.gif'),
        alt: "Cosmetics banner 3",
        title: "Cosmetics banner 3",
        description: "An animated banner that effectively showcases the hair growth brush’s features through dynamic and eye-catching motion graphics.",
        techStack: ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe Illustrator"],
        client: "Cosmetics Brand",
        category: "Banner",
        year: "2022"
      },
      {
        id: 4,
        image: require('@/assets/img/graphic/Cosmetics/04.gif'),
        alt: "Cosmetics banner 4",
        title: "Cosmetics banner 4",
        description: "An animated banner that effectively showcases the hair growth brush’s features through dynamic and eye-catching motion graphics.",
        techStack: ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe Illustrator"],
        client: "Cosmetics Brand",
        category: "Banner",
        year: "2022"
      },
      {
        id: 5,
        image: require('@/assets/img/graphic/PC/001.gif'),
        alt: "PC banner 1",
        title: "PC banner 1",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Adobe Premiere Pro"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 6,
        image: require('@/assets/img/graphic/PC/005.jpg'),
        alt: "PC banner 5",
        title: "PC banner 5",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 7,
        image: require('@/assets/img/graphic/PC/002.jpg'),
        alt: "PC banner 2",
        title: "PC banner 2",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 8,
        image: require('@/assets/img/graphic/PC/003.jpg'),
        alt: "PC banner 3",
        title: "PC banner 3",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 9,
        image: require('@/assets/img/graphic/PC/004.jpg'),
        alt: "PC banner 4",
        title: "PC banner 4",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 10,
        image: require('@/assets/img/graphic/PC/006.jpg'),
        alt: "PC banner 6",
        title: "PC banner 6",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 11,
        image: require('@/assets/img/graphic/PC/007.jpg'),
        alt: "PC banner 7",
        title: "PC banner 7",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 12,
        image: require('@/assets/img/graphic/PC/008.jpeg'),
        alt: "PC banner 8",
        title: "PC banner 8",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 13,
        image: require('@/assets/img/graphic/PC/009.jpg'),
        alt: "PC banner 9",
        title: "PC banner 9",
        description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "OMEN",
        category: "Banner",
        year: "2023"
      },
      {
        id: 14,
        image: require('@/assets/img/graphic/UI/0.png'),
        images: [
          require('@/assets/img/graphic/UI/1.png'),
          require('@/assets/img/graphic/UI/2.png'),
          require('@/assets/img/graphic/UI/3.png'),
          require('@/assets/img/graphic/UI/4.png'),
          require('@/assets/img/graphic/UI/5.jpg'),
          require('@/assets/img/graphic/UI/6.jpg'),
        ],
        alt: "COMPAY UI",
        title: "COMPAY UI",
        description: "A comprehensive UI/UX design project for Comma Talk's mobile application, featuring intuitive user flows, modern visual components, and a cohesive design system that enhances the communication experience.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Figma"],
        client: "Comma Talk",
        category: "UI design",
        year: "2022"
      },
      {
        id: 15,
        image: require('@/assets/img/graphic/other/04.png'),
        alt: "Comma talk poster",
        title: "Comma talk poster",
        description: "A promotional poster designed to attract new users by integrating a QR code for easy access and broader outreach.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "comma talk",
        category: "Poster",
        year: "2022"
      },
      {
        id: 16,
        image: require('@/assets/img/graphic/logo/korekara.jpg'),
        alt: "Korekara Logo",
        title: "Korekara Logo",
        description: "Logo and visual identity design for a fitness gym, crafted to reflect a vibrant and motivational atmosphere.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Korekara gym",
        category: "Logo design",
        year: "2021"
      },
      {
        id: 17,
        image: require('@/assets/img/graphic/logo/wang.png'),
        alt: "Wang Logo",
        title: "Wang Logo",
        description: "This logo was created for an artist, drawing inspiration from a meaningful flower that symbolizes personal memories and emotional depth.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Wang's Work",
        category: "Logo design",
        year: "2022"
      },
      {
        id: 18,
        image: require('@/assets/img/graphic/other/05.jpg'),
        alt: "Korekara facility exterior",
        title: "Korekara facility exterior",
        description: "Logo and visual identity design for a fitness gym, crafted to reflect a vibrant and motivational atmosphere.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Korekara gym",
        category: "Facility exterior design",
        year: "2021"
      },
      {
        id: 19,
        image: require('@/assets/img/graphic/food/002.jpg'),
        alt: "Food banner 1",
        title: "Food banner 1",
        description: "A promotional banner designed for the Jongno EC-commerce website to highlight featured products and convey detailed product information.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Jongno",
        category: "Banner",
        year: "2022"
      },
      {
        id: 20,
        image: require('@/assets/img/graphic/food/003.png'),
        alt: "Food banner 2",
        title: "Food banner 2",
        description: "A promotional banner designed for the Jongno EC-commerce website to highlight featured products and convey detailed product information.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Jongno",
        category: "Banner",
        year: "2022"
      },
      {
        id: 21,
        image: require('@/assets/img/graphic/food/004.png'),
        alt: "Food banner 3",
        title: "Food banner 3",
        description: "A promotional banner designed for the Jongno EC-commerce website to highlight featured products and convey detailed product information.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Jongno",
        category: "Banner",
        year: "2022"
      },
      {
        id: 22,
        image: require('@/assets/img/graphic/food/005.png'),
        alt: "Food banner 4",
        title: "Food banner 4",
        description: "A promotional banner designed for the Jongno EC-commerce website to highlight featured products and convey detailed product information.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Jongno",
        category: "Branding",
        year: "2022"
      },
      {
        id: 23,
        image: require('@/assets/img/graphic/other/01.jpg'),
        alt: "Franchise flyer",
        title: "Franchise flyer",
        description: "A mailbox-distributed flyer designed to attract potential franchise partners with a clear and appealing message.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Wellbe Labo",
        category: "Banner",
        year: "2020"
      },
      {
        id: 24,
        image: require('@/assets/img/graphic/other/03.jpg'),
        alt: "Rental conference room",
        title: "Rental conference room",
        description: "A targeted banner ad created for digital platforms, designed with A/B testing in mind to optimize conversion for rental conference room services.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Rental conference room",
        category: "Banner",
        year: "2020"
      },
      {
        id: 25,
        image: require('@/assets/img/graphic/other/02.jpg'),
        alt: "Rental conference room",
        title: "Rental conference room",
        description: "A targeted banner ad created for digital platforms, designed with A/B testing in mind to optimize conversion for rental conference room services.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator"],
        client: "Rental conference room",
        category: "Banner",
        year: "2020"
      }
    ]
  },
  illustration: {
    title: "Illustration",
    subtitle: "Digital Art & Creative Expression",
    projects: [
      {
        id: 1,
        image: require('@/assets/img/illustrator/00.png'),
        alt: "Drama troupe poster",
        title: "Drama troupe poster",
        description: "A poster designed for a drama troupe, visually presenting character relationships while capturing audience attention through compelling composition and illustration.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Clip studio paint"],
        client: "Drama troupe",
        style: "Digital Art",
        category: "Poster",
        year: "2021"
      },
      {
        id: 2,
        image: require('@/assets/img/illustrator/09.png'),
        alt: "Fan illustrations",
        title: "Fan illustrations",
        description: "Illustrations and costume designs created for a fan comic exhibition.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Clip studio paint"],
        client: "Doujinshi Exhibition",
        style: "Digital Art",
        category: "Illustration",
        year: "2023"
      },
      {
        id: 3,
        image: require('@/assets/img/illustrator/06.jpg'),
        alt: "Character design",
        title: "Character design",
        description: "Character and illustration design for a VTuber, aiming to portray a personality that is both laid-back and lively.",
        techStack: ["Adobe Photoshop", "Clip studio paint"],
        client: "Vtuber",
        style: "Digital Art",
        category: "Character design",
        year: "2022"
      },
      {
        id: 4,
        image: require('@/assets/img/illustrator/10.png'),
        alt: "Fan illustrations",
        title: "Fan illustrations",
        description: "Illustrations and costume designs created for a fan comic exhibition.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Clip studio paint"],
        client: "Doujinshi Exhibition",
        style: "Digital Art",
        category: "Illustration clothes",
        year: "2023"
      },
      {
        id: 5,
        image: require('@/assets/img/illustrator/14.jpg'),
        alt: "Youtube illustration",
        title: "Youtube illustration",
        description: "Character and illustration design for a VTuber, aiming to portray a personality that is both laid-back and lively.",
        techStack: ["Adobe Photoshop", "Clip studio paint"],
        client: "Vtuber",
        style: "Digital Art",
        category: "Illustration",
        year: "2022"
      },
      {
        id: 6,
        image: require('@/assets/img/illustrator/02.jpg'),
        alt: "Character design",
        title: "Character design",
        description: "Designed a Halloween outfit for an existing character, aiming to highlight their mischievous and devilish side.",
        techStack: ["Adobe Photoshop", "Clip studio paint"],
        client: "Social Game",
        style: "Digital Art",
        category: "Character design",
        year: "2023"
      },
      {
        id: 7,
        image: require('@/assets/img/illustrator/11.jpg'),
        alt: "Character design",
        title: "Character design",
        description: "Designed some mascots to create a sense of closeness between the brand and customers, also aiming to help people remember the brand through the characters.",
        client: "Website Mascot",
        style: "Digital Art",
        category: "Character design",
        year: "2023"
      },
      {
        id: 8,
        image: require('@/assets/img/illustrator/13.jpg'),
        alt: "Character design",
        title: "Character design",
        description: "A concept project featuring four characters, each designed based on a different MBTI personality type, inspired by the unique stories and traits of my friends.",
        techStack: ["Adobe Photoshop", "Clip studio paint"],
        client: "Original Character",
        style: "Digital Art",
        category: "Character design",
        year: "2025"
      },
      {
        id: 9,
        image: require('@/assets/img/illustrator/08.jpg'),
        alt: "Commercial illustration draft",
        title: "Commercial illustration draft",
        description: "Draft illustration for OMEN PC's promotional sales at Don Quijote in Japan",
        techStack: ["Adobe Photoshop", "Clip studio paint"],
        client: "OMEN",
        style: "Digital Art",
        category: "Illustration",
        year: "2023"
      },
      {
        id: 10,
        image: require('@/assets/img/illustrator/15.jpeg'),
        alt: "Attack on Titan fan artwork",
        title: "Attack on Titan fan artwork",
        description: "A personal fan art project inspired by Attack on Titan.",
        techStack: ["Adobe Photoshop", "Clip studio paint"],
        client: "Fan Artwork",
        style: "Digital Art",
        category: "Illustration",
        year: "2022"
      },
      {
        id: 11,
        image: require('@/assets/img/illustrator/16.jpeg'),
        alt: "Attack on Titan fan artwork",
        title: "Attack on Titan fan artwork",
        description: "A personal fan art project inspired by Attack on Titan.",
        techStack: ["Adobe Photoshop", "Clip studio paint"],
        client: "Fan Artwork",
        style: "Digital Art",
        category: "Illustration",
        year: "2022"
      }
    ]
  },
  videoEditing: {
    title: "Video Editing",
    subtitle: "Creative Storytelling Through Visual Media",
    projects: [
      {
        id: 1,
        thumbnail: "https://img.youtube.com/vi/5jbQvfIfi4Q/maxresdefault.jpg",
        youtubeId: "5jbQvfIfi4Q",
        alt: "Shiro and Moko 02",
        title: "Shiro and Moko 02",
        description: "A YouTube video made for a friend, where I was mainly responsible for animation editing.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Adobe Premiere Pro", "After Effects"],
        duration: "2 minutes",
        resolution: "1080p",
        achievements: [
        ]
      },
      {
        id: 2,
        thumbnail: "https://img.youtube.com/vi/1b-_y1a3E-8/maxresdefault.jpg",
        youtubeId: "1b-_y1a3E-8",
        alt: "Shiro and Moko 01",
        title: "Shiro and Moko 01",
        description: "A YouTube video made for a friend, where I was mainly responsible for animation editing.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Adobe Premiere Pro", "After Effects"],
        duration: "2 minutes",
        resolution: "1080p",
        achievements: [
        ]
      },
      {
        id: 3,
        thumbnail: "https://img.youtube.com/vi/hqbGUNdoefo/maxresdefault.jpg",
        youtubeId: "hqbGUNdoefo",
        alt: "Comma Talk Introduction Video",
        title: "Comma Talk Introduction Video",
        description: "An animated short created to promote comma talk app and introduce its features.",
        scenarioLink: "/resume2025/pdf/comma.pdf",
        scenarioLabel: "Storyboard",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Adobe Premiere Pro", "After Effects"],
        duration: "2.5 minutes",
        resolution: "1080p",
        achievements: [
        ]
      },
      {
        id: 4,
        thumbnail: "https://img.youtube.com/vi/fqoDJRKatHw/maxresdefault.jpg",
        youtubeId: "fqoDJRKatHw",
        alt: "Grant Application Guide",
        title: "Grant Application Guide",
        description: "An animated video designed to guide people through the process of applying for a grant.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Adobe Premiere Pro", "After Effects"],
        duration: "12 minutes",
        resolution: "1080p",
        achievements: [
        ]
      },
      {
        id: 5,
        thumbnail: "https://img.youtube.com/vi/wGhd7Hc5mNU/maxresdefault.jpg",
        youtubeId: "wGhd7Hc5mNU",
        alt: "Gym promotional shorts",
        title: "Gym promotional shorts",
        description: "A promotional video created for a gym, featuring interviews with trainers and an introduction to various training programs.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Adobe Premiere Pro", "After Effects"],
        duration: "3 minutes",
        resolution: "1080p",
        achievements: [
        ]
      },
      {
        id: 6,
        thumbnail: require('@/assets/img/vedio4.png'),
        youtubeId: "Yx8FGEmqG5I",
        alt: "Wellbe Labo franchise Video",
        title: "Wellbe Labo franchise Video",
        description: "An animated video created to attract franchise partners for Wellbe Labo, introducing the Wellbe Labo’s services and the benefits of becoming a franchisee.",
        techStack: ["Adobe Photoshop", "Adobe Illustrator", "Adobe Premiere Pro", "After Effects"],
        duration: "15 minutes",
        resolution: "1080p",
        achievements: [
        ]
      }
    ]
  },
  sqlDatabase: {
    title: "SQL Database",
    subtitle: "Data Management",
    projects:
      [
        {
          id: 1,
          banner: require('@/assets/img/salesforce.jpeg'),
          title: "Salesforce",
          description: "Use Salesforce to manage customers and orders.",
          techStack: ["Apex", "Lightning", "Visualforce"]
        },
        {
          id: 2,
          banner: require('@/assets/img/sql.png'),
          title: "SQL",
          description: "Use SQL to extract and modify database content.",
          techStack: ["MAVEN tools", "Dev tools"]
        }
      ]
  },
  information: {
    title: "About Me",
    subtitle: "My Profile & Contact Info",
    profile: {
      image: require('@/assets/img/author.jpg'),
      name: "Cao Yuxuan",
      title: "Web Designer / Graphic Designer / Illustrator",
      contact: [
        {
          icon: "fas fa-envelope",
          text: "ouinemelles2@gmail.com",
          link: "ouinemelles2@gmail.com"
        },
        {
          icon: "fas fa-map-marker-alt",
          text: "Tokyo, Japan",
          link: "https://maps.google.com/?q=Tokyo,Japan"
        }
      ],
      social: [
        {
          icon: "fab fa-linkedin",
          link: "https://www.linkedin.com/in/yuzuha0427/",
          label: "LinkedIn"
        },
        {
          icon: "fab fa-instagram",
          link: "https://www.instagram.com/oyim_0427/",
          label: "Instagram"
        }
      ]
    },
    skills: [
      {
        category: "Web Development",
        icon: "fas fa-code",
        items: [
          {
            name: "HTML5 / CSS3",
            level: 95
          },
          {
            name: "JavaScript / jQuery",
            level: 90
          },
          {
            name: "Node.js / Vue.js",
            level: 75
          },
          {
            name: "SQL / Salesforce",
            level: 70
          }
        ]
      },
      {
        category: "Design Tools",
        icon: "fas fa-palette",
        items: [
          {
            name: "Photoshop",
            level: 100
          },
          {
            name: "Illustrator",
            level: 100
          },
          {
            name: "Premiere Pro",
            level: 80
          },
          {
            name: "After Effects",
            level: 70
          },
          {
            name: "Figma",
            level: 95
          },
          {
            name: "Clip Studio Paint",
            level: 100
          }
        ]
      },
      {
        category: "Languages",
        icon: "fas fa-language",
        items: [
          {
            name: "Japanese",
            level: 80,
            note: "Proficient"
          },
          {
            name: "English",
            level: 70,
            note: "Intermediate"
          },
          {
            name: "Chinese",
            level: 100,
            note: "Fluent"
          }
        ]
      }
    ],
    experience: [
      {
        period: "2023 - Present",
        title: "Web Developer & Web Designer / Graphic Designer",
        description: "Building responsive websites and web applications, while also creating visual assets and brand-consistent designs.",
        responsibilities: [
          "Developed and maintained responsive websites and web applications using relevant web technologies",
          "Designed user-friendly interfaces and implemented them into fully functional web pages",
          "Created a variety of marketing assets, including banners, social media graphics, and infographics",
          "Communicated with clients together with my leader to understand their needs and deliver customized web solutions"
        ]
      },
      {
        period: "2020 - 2023",
        title: "Web Designer / Graphic Designer & Illustrator",
        description: "Designed a variety of product visuals for various media across digital and print platforms.",
        responsibilities: [
          "Designed website layouts, UI components, and brand visual elements for a variety of clients",
          "Created custom illustrations for both web and print to enhance visual storytelling",
          "Collaborated closely with developers to build e-commerce websites with consistent cross-platform design",
          "Contributed to both online and offline advertising designs, including promotional images, banners, and posters"
        ]
      }
    ]
  }
};
